"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dataGridNavbar = _interopRequireDefault(require("./data-grid-navbar"));

var _dataGridBody = _interopRequireDefault(require("./data-grid-body"));

var _dataGridFooter = _interopRequireDefault(require("./data-grid-footer"));

var _dataGridAlignment = _interopRequireDefault(require("./data-grid-alignment"));

var _dataGridContext = _interopRequireDefault(require("./data-grid-context"));

var _dataGridAutocomplete = _interopRequireDefault(require("./data-grid-autocomplete"));

var DataGrid = function DataGrid(_ref) {
  var children = _ref.children,
      defaultView = _ref.defaultView,
      serverSidePagination = _ref.serverSidePagination,
      datasource = _ref.datasource,
      pageSize = _ref.pageSize,
      forceDataUpdate = _ref.forceDataUpdate;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showTable = _useState2[0],
      setShowTable = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showCards = _useState4[0],
      setShowCards = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      showDoItYourselfView = _useState6[0],
      setShowDoItYourselfView = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      filters = _useState8[0],
      setFilters = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
      categoryFilters = _useState10[0],
      setCategoryFilters = _useState10[1];

  var _useState11 = (0, _react.useState)(''),
      _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
      searchQuery = _useState12[0],
      setSearchQuery = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
      selectedNodes = _useState14[0],
      setSelectedNodes = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
      filterActive = _useState16[0],
      setFilterActive = _useState16[1];

  var _useState17 = (0, _react.useState)(false),
      _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
      filterSelectorActive = _useState18[0],
      setFilterSelectorActive = _useState18[1];

  var _useState19 = (0, _react.useState)([]),
      _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
      filterSelectorHeaders = _useState20[0],
      setFilterSelectorHeaders = _useState20[1];

  var _useState21 = (0, _react.useState)(null),
      _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
      hasTableView = _useState22[0],
      setHasTableView = _useState22[1];

  var _useState23 = (0, _react.useState)(null),
      _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
      hasCustomView = _useState24[0],
      setHasCustomView = _useState24[1];

  var _useState25 = (0, _react.useState)(null),
      _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
      hasDoItYourselfView = _useState26[0],
      setHasDoItYourselfView = _useState26[1];

  var _useState27 = (0, _react.useState)(null),
      _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
      gridApi = _useState28[0],
      setGridApi = _useState28[1];

  var _useState29 = (0, _react.useState)(),
      _useState30 = (0, _slicedToArray2["default"])(_useState29, 2),
      pageData = _useState30[0],
      setPageData = _useState30[1];

  var _useState31 = (0, _react.useState)(1),
      _useState32 = (0, _slicedToArray2["default"])(_useState31, 2),
      currentPage = _useState32[0],
      setCurrentPage = _useState32[1]; // Pagination api used for serverside pagination only


  var paginationApi = {
    /**
     * Used to navigate to a page of
     * @param {number} pageNumber - The page number
     * @param {pageSize} pageSize - The page size
     */
    goToPage: function goToPage(pageNumber, pageSize) {
      // Check server side pagination is enabled
      if (!serverSidePagination) {
        throw new Error('Pagination API should only be used for serverside pagination');
      } // Table can use grid api from aggrid


      if (showTable && gridApi) {
        gridApi.paginationGoToPage(pageNumber - 1);
      } else {
        // Get new page data with datasource
        datasource === null || datasource === void 0 ? void 0 : datasource.getRows({
          request: {
            endRow: pageNumber * pageSize,
            startRow: (pageNumber - 1) * pageSize
          },
          parentNode: {
            context: {
              query: searchQuery
            }
          },
          successCallback: setPageData
        });
      } // Set current pagenumber in state


      setCurrentPage(pageNumber);
    },

    /**
     * Returns current page number
     */
    getCurrentPageNumber: function getCurrentPageNumber() {
      // Check if server side pagination is enabled
      if (!serverSidePagination) {
        throw new Error('Pagination API should only be used for serverside pagination');
      }

      return currentPage;
    }
  }; // Set callback which is used to force update data

  (0, _react.useEffect)(function () {
    forceDataUpdate(function () {
      return paginationApi.goToPage(currentPage, pageSize);
    });
  }, []); // Custom / diy view need this on init to get first page data

  (0, _react.useEffect)(function () {
    if ((showCards || showDoItYourselfView) && serverSidePagination) {
      paginationApi.goToPage(currentPage, pageSize);
    }
  }, [showCards, showDoItYourselfView]); // Switching between table / custom / diy view

  (0, _react.useEffect)(function () {
    if (defaultView) {
      switch (defaultView) {
        case 'Cards':
          if (hasCustomView) {
            setShowCards(true);
            setShowTable(false);
            return;
          }

          break;

        case 'DoItYourself':
          if (hasDoItYourselfView) {
            setShowDoItYourselfView(true);
            setShowTable(false);
            return;
          }

          break;

        default:
          if (hasTableView) {
            setShowTable(true);
            setShowCards(false);
            return;
          }

      }
    }

    if (hasCustomView && hasTableView) {
      setShowTable(true);
    } else if (hasCustomView && !hasTableView) {
      setShowCards(true);
    } else if (!hasCustomView && hasTableView) {
      setShowTable(true);
    } else if (hasDoItYourselfView) {
      setShowDoItYourselfView(true);
    }
  }, [hasCustomView, hasTableView, hasDoItYourselfView, defaultView]);
  return /*#__PURE__*/_react["default"].createElement(_dataGridContext["default"].Provider, {
    value: {
      showTable: showTable,
      setShowTable: setShowTable,
      showCards: showCards,
      setShowCards: setShowCards,
      searchQuery: searchQuery,
      setSearchQuery: setSearchQuery,
      hasTableView: hasTableView,
      setHasTableView: setHasTableView,
      hasCustomView: hasCustomView,
      setHasCustomView: setHasCustomView,
      filters: filters,
      setFilters: setFilters,
      selectedNodes: selectedNodes,
      setSelectedNodes: setSelectedNodes,
      filterActive: filterActive,
      setFilterActive: setFilterActive,
      filterSelectorActive: filterSelectorActive,
      setFilterSelectorActive: setFilterSelectorActive,
      filterSelectorHeaders: filterSelectorHeaders,
      setFilterSelectorHeaders: setFilterSelectorHeaders,
      categoryFilters: categoryFilters,
      setCategoryFilters: setCategoryFilters,
      showDoItYourselfView: showDoItYourselfView,
      setShowDoItYourselfView: setShowDoItYourselfView,
      hasDoItYourselfView: hasDoItYourselfView,
      setHasDoItYourselfView: setHasDoItYourselfView,
      gridApi: gridApi,
      setGridApi: setGridApi,
      paginationApi: paginationApi,
      pageData: pageData
    }
  }, children);
};

DataGrid.Autocomplete = _dataGridAutocomplete["default"];
DataGrid.Navbar = _dataGridNavbar["default"];
DataGrid.Body = _dataGridBody["default"];
DataGrid.Footer = _dataGridFooter["default"];
DataGrid.Alignment = _dataGridAlignment["default"];
DataGrid.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  datasource: _propTypes["default"].object,
  defaultView: _propTypes["default"].oneOf(['Table', 'Cards', 'DoItYourself']),
  forceDataUpdate: _propTypes["default"].func,
  pageSize: _propTypes["default"].number,
  serverSidePagination: _propTypes["default"].bool
};
DataGrid.defaultProps = {
  forceDataUpdate: function forceDataUpdate() {}
};
var _default = DataGrid;
exports["default"] = _default;